<template>
  <v-dialog
    v-model="shown"
    max-width="967"
    @click:outside="cancel">
    <div v-if="asyncDataStatus_ready" class="col-full popup">
      <h2>
        Dodajte novo mizo:
      </h2>

      <TableForm
        @save="save"
        @cancel="close"
        :emitClose="true"
        :locations="locations"
        :tables="tables"
        :table="table"
        ref="form"
      />
    </div>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import TableForm from '@/components/TableForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    TableForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    table: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      shown: false
    }
  },
  computed: {
    locations () {
      return objectToArray(this.$store.state.locations.items)
    },
    tables () {
      return objectToArray(this.$store.state.tables.items)
    }
  },
  methods: {
    ...mapActions('tables', { saveItem: 'saveItem', loadTables: 'loadItems' }),
    ...mapActions('locations', { loadLocations: 'loadItems' }),
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : 'MyCompanyTables'
      data.type = !data.type ? 0 : 1
      this.saveItem({ id: this.id, ...data })
      .then(item => {
        this.$refs.form.saveAndRepeatClear()
        /* this.$notify({
          type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
            }) */
          if (redirect) {
             /* this.$router.push({ name: redirect }) */
            this.shown = false
            this.$emit('close')
          } else {
            // this.$refs.form.clearForm()
            this.$refs.form.disabled = true
          }
        })
    },
    open () {
      this.shown = true
    },
    close () {
      this.shown = false
      this.$emit('close')
    },

  },
  created () {
    Promise.all([
      this.loadLocations(),
      this.loadTables()
    ])
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>

<style scoped lang="scss">
  .popup {
    background-color: #fff;
    padding: 1rem;
    min-height: calc(100vh - 130px);
    /* overflow: auto; */
  }
</style>
